import svg from 'src/assets/pin-disconnected.raw.svg';
import SvgMarker from './SvgMarker';

export default class DisconnectedSvgMarker extends SvgMarker {
  constructor() {
    super(svg, {
      height: 91,
      width: 60,
      innerColor: '#fff',
      outerColor: '#C10015', // TODO: replace these with Quasar variables
    });
  }
}
